<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="700">
    <template v-slot:title>VAT Breakdown</template>
    <v-container fluid v-if="$apollo.loading">
      <v-row justify="center" align="center"
        ><v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular
      ></v-row>
    </v-container>
    <v-data-table :items="items" :headers="headers" v-else>
      <template v-slot:item.vatCode="{ item }">
        {{ `${item.vatCode} (${item.vatPercent}%)` }}
      </template>
      <template v-slot:item.netAmount="{ item }">
        <v-text-field
          v-model.number="item.netAmount"
          @change="onNetAmountChange(item)"
        />
      </template>
      <template v-slot:item.vatAmount="{ item }">
        <v-text-field
          v-model.number="item.vatAmount"
          @change="onVatAmountChange(item)"
        />
      </template>
      <template v-slot:item.grossAmount="{ item }">
        <v-text-field
          v-model.number="item.grossAmount"
          @change="onGrossAmountChange(item)"
        />
      </template>
    </v-data-table>
    <div v-if="debug">
      <code>{{ items }}</code>
    </div>
    <template v-slot:actions>
      <v-btn color="primary" @click="onApprove">Approve</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../../shared/BasicDialog.vue";
import { removeGQLTypename } from "../../../../helpers";
const randomize = require("randomatic");
const PI_VAT_BREAKDOWN = gql`
  query piVATBreakdown($id: ID!) {
    purchaseInvoice(id: $id) {
      id
      vatAmount
      netAmount
      amount
      vatBreakdown {
        vatCode
        vatAmount
        vatPercent
        netAmount
        grossAmount
      }
    }
  }
`;

export default {
  name: "vat-breakdown-dialog",

  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      items: [],
      headers: [
        {
          text: "VAT Code",
          value: "vatCode",
          name: "vatCode",
        },
        {
          text: "Net Amount",
          value: "netAmount",
          name: "netAmount",
        },
        {
          text: "VAT Amount",
          value: "vatAmount",
          name: "vatAmount",
        },
        {
          text: "Gross Amount",
          value: "grossAmount",
          name: "grossAmount",
        },
      ],
    };
  },

  computed: {
    // items() {
    //   return this.purchaseInvoice
    //     ? this.purchaseInvoice.vatBreakdown.map(removeGQLTypename)
    //     : [];
    // },
  },

  methods: {
    onApprove() {
      this.$emit("approve", [
        ...this.items.map((b) => ({
          ...b,
          vatAmount: Number(b.vatAmount),
          netAmount: Number(b.netAmount),
          grossAmount: Number(b.grossAmount),
        })),
      ]);
    },
    onGrossAmountChange(item) {
      const editedItem = this.items.find((i) => i.id == item.id);
      if (editedItem) {
        const vatPercent = Number(editedItem.vatPercent);

        const gross = Number(item.grossAmount);
        const vatAmount = gross - gross / (1 + vatPercent / 100);
        editedItem.vatAmount = Number(vatAmount).toFixed(2);
        editedItem.netAmount = Number(gross - vatAmount).toFixed(2);
      }

      //Object.assign(this.items[editedIndex], { ...payload });
    },
    onVatAmountChange(item) {
      const editedItem = this.items.find((i) => i.id == item.id);
      if (editedItem) {
        editedItem.grossAmount = (
          Number(item.netAmount) + Number(editedItem.vatAmount)
        ).toFixed(2);
      }
    },
    onNetAmountChange(item) {
      const editedItem = this.items.find((i) => i.id == item.id);
      if (editedItem) {
        editedItem.grossAmount = (
          Number(editedItem.netAmount) + Number(item.vatAmount)
        ).toFixed(2);
      }
    },
  },

  apollo: {
    purchaseInvoice: {
      query: PI_VAT_BREAKDOWN,
      fetchPolicy: "network-only",
      variables() {
        return { id: this.value.id };
      },
      skip() {
        //console.log("skip", this.value == null || !this.value.id);
        return this.value == null || !this.value.id;
      },
      result({ data }) {
        //console.log("result", data);
        this.items = [
          ...data.purchaseInvoice.vatBreakdown
            .map(removeGQLTypename)
            .map((item) => ({ id: randomize("Aa0", 32), ...item })),
        ];
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/finances/pi-approvals/VatBreakdownDialog.vue